// //

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";

import Particless from "./Growth_Particles";
import growth_icon from "../../../images/igg.png";
import MarketResearcher from "../../../images/MarketResearcher.gif";
import Loader from "../../../images/loader.gif";
import Header from "../../navbars/Header";
import { getPaymentUrl } from "../../actions/payments.js";
import { getUserById } from "../../actions/users";
import SquareCardForm from "../../Paymets/SquareCardForm.js";

const MarketResearchAI = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [hasUsedFreeReport, setHasUsedFreeReport] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [businessDetails, setBusinessDetails] = useState("");
  const [reports, setReports] = useState([]);
  const [authToken, setAuthToken] = useState("");

  const authStr = localStorage.getItem("auth");
  const token = authStr ? JSON.parse(authStr)?.data?.access_token : "";

  useEffect(() => {
    // const fetchUser = async () => {
    //   const authStr = localStorage.getItem("auth");
    //   const authObj = JSON.parse(authStr);
    //   const userId = authObj?.data?.userData?.id;
    //   const token = authObj?.data?.access_token || "";
    //   setAuthToken(token); // ✅ save to state

    //   if (!userId) {
    //     navigate("/login");
    //     return;
    //   }

    //   try {
    //     const res = await getUserById(userId);
    //     const user = res.data;
    //     setUser(user);

    //     const expiryDate = new Date(user.marketresearchExpiry);
    //     const now = new Date();
    //     const subscribed = user.marketresearch && expiryDate > now;
    //     const usedFree = user.hasUsedFreeReport;

    //     setIsSubscribed(subscribed);
    //     setHasUsedFreeReport(usedFree);

    //     const allowed = user.isAdmin || subscribed || !usedFree;
    //     setIsAllowed(allowed);
    //   } catch (err) {
    //     console.error("❌ Failed to fetch user:", err);
    //     navigate("/login");
    //   }
    // };

    const fetchUser = async () => {
      const authStr = localStorage.getItem("auth");
      const authObj = JSON.parse(authStr);
      const userId = authObj?.data?.userData?.id;
      const token = authObj?.data?.access_token || "";

      if (!userId) {
        navigate("/login");
        return;
      }

      try {
        // Step 1: Fetch user info
        let res = await getUserById(userId);
        let user = res.data;
        setUser(user);
        setAuthToken(token);

        const expiryDate = new Date(user.marketresearchExpiry);
        const now = new Date();
        const subscribed = user.marketresearch && expiryDate > now;
        const usedFree = user.hasUsedFreeReport;
        setIsSubscribed(subscribed);
        setHasUsedFreeReport(usedFree);
        setIsAllowed(user.isAdmin || subscribed || !usedFree);

        // Step 2: If customer ID is missing, create it now
        if (!user.square_customer_id) {
          const response = await axios.post(
            "https://ironglassbyte.com:5000/payments/create-customer",
            {
              email: user.email,
              userId: user.id,
            }
          );

          if (response.data?.customerId) {
            // Refetch user to get updated square_customer_id
            res = await getUserById(userId);
            user = res.data;
            setUser(user);
            console.log(user); // Update with new customerId
            console.log(
              "✅ Square customer created and saved:",
              response.data.customerId
            );
          } else {
            throw new Error("Customer creation failed");
          }
        }
      } catch (err) {
        console.error("❌ Failed to fetch or update user:", err);
        navigate("/login");
      }
    };

    const params = new URLSearchParams(window.location.search);
    const service = params.get("service");
    if (service === "marketresearch") {
      toast("✅ Payment successful! Subscription activated.", {
        style: { background: "#C0C0C0", color: "#000" },
      });
    }

    fetchUser();
  }, [navigate, authStr]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isAllowed || !user) {
      toast("Please subscribe to access this feature.", {
        style: { background: "#C0C0C0", color: "#000" },
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://ironglassbyte.com:5000/api/generate-report",
        {
          name: user.user_name,
          phone: user.phone || "N/A",
          email: user.email,
          userId: user.id,
          businessDetails,
        }
      );

      setReports([response.data, ...reports]);
      setBusinessDetails("");
    } catch (error) {
      console.error("Report error:", error.message);
      toast.error("Failed to generate report. Try again.");
    }

    setTimeout(() => setLoading(false), 3000);
  };

  return (
    <div>
      <Helmet>
        <title>Market Research Services - IronGlass Byte</title>
        <meta
          name="description"
          content="Get powerful AI-driven Market Research with IronGlass Byte. Generate custom business insights, competitor analysis, and receive weekly reports to stay ahead in your industry."
        />
        <meta
          name="keywords"
          content="Market Research, AI Market Analysis, Competitor Research, Business Insights, Weekly Reports, IronGlass Byte, Business Intelligence"
        />
        <meta
          property="og:title"
          content="Market Research Services | IronGlass Byte"
        />
        <meta
          property="og:description"
          content="Stay competitive with IronGlass Byte's AI Market Research service. Create personalized reports and receive weekly business insights directly to your inbox."
        />
        <meta
          property="og:url"
          content="https://www.ironglassbyte.com/#/MarketResearch"
        />
        <meta
          property="og:image"
          content="https://www.ironglassbyte.com/images/Ironglass_Growth_icon_stylized_v003.png"
        />
        <link
          rel="canonical"
          href="https://www.ironglassbyte.com/#/MarketResearch"
        />
      </Helmet>

      <Particless />
      <div className="lg:px-12 mt-8 md:px-10 lg:m-5 mb-4 lg:mb-10">
        <div>
          <h1 className="text-4xl lg:text-6xl flex text-[#C0C0C0] p-2 lg:p-4 m-2 font-bold">
            Market Research
          </h1>

          <div className="flex flex-col lg:flex-row">
            <p className="text-xl lg:text-2xl card p-2 m-2 lg:m-4 border border-[#3bb24d] rounded-xl">
              <span className="text-[#3bb24d] font-bold mb-2">
                IronGlass Growth - Market Research
              </span>{" "}
              provides advanced Market Research to help businesses gain a
              competitive edge through in-depth market analysis.
              <p className="text-xl lg:text-2xl my-2 rounded-xl">
                Subscribe now to unlock access to generate custom business
                reports and receive weekly insights delivered straight to your
                inbox in just $1 per month
              </p>
            </p>
            <img
              className="h-40 lg:h-[23rem] p-2 lg:p-5 rounded-lg z-10"
              src={growth_icon}
              alt="Ironglass Growth Icon"
            />
          </div>
        </div>

        <div className="card border border-[#3bb24d] p-6 rounded-lg bg-black shadow-md">
          {loading ? (
            <div className="flex justify-center">
              <img className="h-96 w-96" src={Loader} alt="Loading..." />
            </div>
          ) : reports.length === 0 ? (
            <div>
              <div className="text-4xl flex justify-center text-[#C0C0C0] pt-5 font-bold mb-4">
                Start Your Market Research Now
              </div>

              <form onSubmit={handleSubmit} className="mb-6">
                <h2 className="text-2xl text-[#43d45b] font-semibold mt-6 mb-5">
                  Enter Your Business Details{" "}
                  <span className="text-[#C0C0C0]"> {user?.user_name} </span>
                </h2>
                <textarea
                  className="w-full p-2 text-[#C0C0C0] text-lg bg-slate-800 opacity-75 border rounded-lg"
                  rows="8"
                  placeholder="Enter your business name, product/service, unique features, and target market..."
                  value={businessDetails}
                  onChange={(e) => setBusinessDetails(e.target.value)}
                  required
                ></textarea>

                <button
                  type="submit"
                  className="mt-4 px-6 py-2 bg-[#3bb24d] text-black rounded text-lg font-semibold"
                >
                  Generate Report
                </button>

                {user?.isAdmin ? (
                  <div className="mt-4 ml-4 px-6 py-2 bg-[#0b1b0d] text-[#33cd4a] rounded text-lg font-semibold text-center">
                    🛡️ {user?.user_name} is an Admin. Lifetime access granted.
                  </div>
                ) : user?.isSubscribed ? (
                  <div className="flex justify-center">
                    <button
                      type="button"
                      className="mt-4 ml-4 px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded text-lg font-semibold"
                      onClick={async () => {
                        try {
                          await axios.post(
                            "https://ironglassbyte.com:5000/payments/cancel-subscription",
                            {
                              email: user.email,
                            }
                          );
                          toast.success("Subscription cancelled successfully.");
                          setIsSubscribed(false);
                          setIsAllowed(user.isAdmin || false);
                        } catch (err) {
                          console.error("❌ Cancel error:", err);
                          toast.error("Failed to cancel subscription.");
                        }
                      }}
                    >
                      Cancel Subscription
                    </button>
                  </div>
                ) : !user?.hasUsedFreeReport ? (
                  <div className="mt-4 ml-4 px-6 py-2 bg-blue-700 text-white rounded text-lg font-semibold text-center">
                    🎁 {user?.user_name} You are eligible for 1 free market
                    research report
                  </div>
                ) : (
                  <div className="mt-6">
                    <div className="text-white text-center font-semibold mb-3">
                      Subscribe to unlock report generation and weekly insights.
                    </div>
                    <SquareCardForm
                      customerId={user?.square_customer_id} // ✅ now it gets passed
                      token={authToken}
                      onSuccess={() => {
                        toast.success("✅ Subscribed successfully!");
                        setIsSubscribed(true);
                        setIsAllowed(true);
                      }}
                    />
                  </div>
                )}
              </form>
            </div>
          ) : (
            <div>
              <h2 className="font-semibold py-3 flex text-[#43d45b] justify-center text-3xl mb-3">
                <span className="text-[#C0C0C0]">{user?.user_name}</span>Your
                Business Report
              </h2>
              <div className="flex justify-center">
                <img
                  className="h-36 w-36"
                  src={MarketResearcher}
                  alt="Market Research"
                />
              </div>
              <div className="space-y-4">
                {Array.isArray(reports) &&
                  reports.map((report, index) => (
                    <div
                      key={index}
                      className="p-4 border rounded-lg shadow-sm bg-slate-900 text-[#C0C0C0]"
                    >
                      <pre className="whitespace-pre-wrap">
                        {report.content}
                      </pre>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarketResearchAI;
